<template>
  <Layout>
      <b-card>
          <b-card-header>
              <b-card-title>Para Yatırma İstatistikleri</b-card-title>
          </b-card-header>
      </b-card>
      <div class="row d-print-none">
          <div class="col-12">
              <div class="card">
                  <div class="card-body">
                      <h4 class="card-title">Detaylı Arama</h4>
                      <form class="repeater" @submit.prevent="get">
                          <div data-repeater-list="group-a">
                              <div class="row">
                                  <div class="col-sm-2">
                                      <b-form-group
                                              label="Başlangıç Tarihi"
                                              label-for="input-1"
                                      >
                                          <b-form-datepicker  v-model="startDate" class="mb-2"></b-form-datepicker>
                                      </b-form-group>
                                  </div>
                                  <div class="col-sm-2">
                                      <b-form-group
                                              label="Bitiş Tarihi"
                                              label-for="input-1"
                                      >
                                          <b-form-datepicker  v-model="endDate" class="mb-2"></b-form-datepicker>
                                      </b-form-group>
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>Gönderen</label>
                                      <input
                                              type="text"
                                              v-model="name"
                                              class="form-control"
                                      />
                                  </div>
                                  <div class="form-group col-sm-2">
                                      <label>İşlem Yapan Kull.</label>
                                      <v-select :options="admins" v-model="admin_id "></v-select>
                                  </div>
                                  <div class="form-group col-sm-4">
                                      <label>Banka Hesabı</label>
                                      <v-select :options="bank_accounts" v-model="bank_account_id" multiple></v-select>
                                  </div>
                                  <div class="col-lg-2 align-self-center">
                                      <b-button-group>
                                          <b-button v-if="loading" variant="info" type="submit" class="btn-sm"> <i class="fa fa-spinner fa-spin" /> </b-button>
                                          <b-button v-else variant="info" type="submit" class="btn-sm"> <i class="fa fa-search" /> Ara</b-button>
                                          <b-button variant="danger" @click="clearSearchForm" class="btn-sm"> <i class="fa fa-trash" /> Sıfırla</b-button>

                                      </b-button-group>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
          <div class="col-md-6">
              <div class="row">
                  <div class="col-md-6">
                      <b-card>
                          <b-card-header>Başarılı Ödemeler</b-card-header>
                          <b-card-body>{{ approvedAmount | currency }} TL</b-card-body>
                      </b-card>
                  </div>
                  <div class="col-md-6">
                      <b-card>
                          <b-card-header>Yönetim Onayı Bekleyen</b-card-header>
                          <b-card-body>{{ manualAmount | currency }} TL</b-card-body>
                      </b-card>
                  </div>

              </div>
          </div>
          <div class="col-md-6">
              <b-card>
                  <b-table :items="siteStatistics"
                           :fields="siteFields"
                           responsive="sm"
                           show-empty
                           striped
                  >
                      <template v-slot:empty="">
                          <b-alert show variant="warning">
                              Kayıt bulunamadı.
                          </b-alert>
                      </template>
                      <template v-slot:cell(approvedTotal)="data">
                          {{data.item.approvedTotal | currency}} TL
                      </template>


                  </b-table>
              </b-card>
          </div>
      </div>
      <b-card>
          <b-card-header>
              <b-card-title>Para Çekme İstatistikleri</b-card-title>
          </b-card-header>
      </b-card>
      <WithdrawalsStatistics></WithdrawalsStatistics>

  </Layout>
</template>
<script>
import Layout from "../layouts/main";
import appConfig from "@/app.config";
import bankAccountsService from "@/services/bankAccountsService";
import depositService from "@/services/depositService";
import WithdrawalsStatistics from "@/router/views/withdrawals/WithdrawalsStatistics.vue";
export default {
  page: {
    title: "Anasayfa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, WithdrawalsStatistics },
  data() {
    return {
      apiResponse: {notification_url: '', message: ''},
      readId: 0,
      title: "Anasayfa",
      items: [
        {
          text: "Anasayfa",
          to: "/"
        },

      ],
      name : '',
      fields: [
        {key: 'id', label: 'ID', sortable: false },
        {key: 'site_id', label: 'Site', sortable: true },
        {key: 'bank_name', label: 'Banka Adı', sortable: true },
        {key: 'account_name', label: 'Hesap Bilgileri', sortable: true },
        {key: 'tc', label: 'Tc', sortable: true },
        {key: 'name', label: 'Gönderen', sortable: true },
        {key: 'amount', label: 'Tutar', sortable: true },
        {key: 'status', label: 'Durum', sortable: false },
        {key: 'api_service', label: 'API', sortable: false },
        {key: 'date', label: 'Tarih', sortable: false },
        {key: 'details', label: '#', sortable: false },
        {key: 'user_id', label: 'Düzenleyen', sortable: false },

      ],
      id: '',
      tableData: [],
      totalRows: 0,
      loading: true,
      perPage : 0,
      currentPage: 1,
      tabStatus : 'waiting_site',
      sites: [],
      startDate: '',
      endDate: '',
      answerMessages: [],
      api_trx: '',
      account_name: '',
      account_number: '',
      admins: [],
      admin_id: '',
      approvedTotal: 0,
      approvedAmount: 0,
      manualTotal: 0,
      manualAmount: 0,
      mailTotal: 0,
      mailAmount: 0,
      activatedSites: [],
      siteStatistics: [],
      siteFields: [
        {key: 'site_name', label: 'Site', sortable: false },
        {key: 'approvedTotal', label: 'Yatırım Tutarı', sortable: false },
      ],
      payment_type: '',
      panel_two: false,
      panel_two_loading: true,
      paymentId: '',
      tc:'',
      tc_sorgu_response: null,
      bank_accounts: [],
      bank_account_id: '',
        withdrawal: {
            trx: '',
            apiResponse: {notification_url: '', message: ''},
            readId: 0,
            title: "Para Çekme İşlemleri",
            items: [
                {
                    text: "Anasayfa",
                    to: "/"
                },
                {
                    text: "Para Çekme İşlemleri",
                    active: true
                }
            ],
            name : '',
            fields: [
                {key: 'id', label: 'ID', sortable: false },
                {key: 'status', label: 'Durum', sortable: false },
                {key: 'site_id', label: 'Site', sortable: true },
                {key: 'bank_name', label: 'Banka', sortable: true },
                {key: 'name', label: 'İsim Soyisim', sortable: true },
                {key: 'tc', label: 'T.C Kimlik', sortable: true },
                {key: 'iban', label: 'IBAN', sortable: true },
                {key: 'amount', label: 'Tutar', sortable: true },
                {key: 'date', label: 'Tarih', sortable: false },
                {key: 'api', label: 'API', sortable: false },
                {key: 'user_id', label: '#', sortable: false },
            ],
            id: '',
            tableData: [],
            totalRows: 0,
            loading: true,
            perPage : 0,
            currentPage: 1,
            tabStatus : 'waiting_site',
            site_id: '',
            sites: [],
            startDate: this.$route.query.start_date,
            endDate: this.$route.query.end_date,
            answerMessages: [],
            api_trx: '',
            account_name: '',
            account_number: this.$route.query.account_number,
            admins: [],
            admin_id: '',
            approvedTotal: 0,
            approvedAmount: 0,
            declinedAmount: 0,
            waitingAmount: 0,
            manualTotal: 0,
            manualAmount: 0,
            mailTotal: 0,
            mailAmount: 0,
            siteStatistics: [],
            sitesStatistics: [],
            payment_type: '',
            bank_name: '',
            statusData: [
                {
                    value: '',
                    text: 'Tümü'
                },
                {
                    value: '3',
                    text: 'Bekleyen'
                },
                {
                    value: '1',
                    text: 'Onaylanan'
                },
                {
                    value: '2',
                    text: 'Red Edilen'
                }
            ],
            status_id: '',
            siteFields: [
                {key: 'site_name', label: 'Site', sortable: false },
                {key: 'approvedTotal', label: 'Başarılı ', sortable: false },
            ],
        }
    };
  },
  methods: {
    get() {
      this.getStatistics()
    },
    messages() {
      bankAccountsService.answers()
          .then((res) => {
            if(res.state)
              res.data.map((msg) => {
                this.answerMessages.push(msg.text)
              })
          })
    },
    panelTwoEdit() {
      depositService.panelTwoEdit()
          .then(() => {
            this.panelTwoCheck()
          })
    },
    clearSearchForm() {
      this.payment_id = ''
      this.api_return_id = ''
      this.api_id = ''
      this.startDate = ''
      this.endDate = ''
      this.id = ''
    },
    readMail(id) {
      this.readId = id
      setTimeout(() => {
        this.$bvModal.show('readMailModal')
      }, 100)
    },
    apiMessage(item) {
      this.apiResponse = item
      setTimeout(() => {
        this.$bvModal.show('apiMessageModal')
      }, 100)
    },
    getSites() {
      depositService.getSites()
          .then((res) => {
            if(res.state){
              this.activatedSites = res.data
              this.getSiteStatistics()
              this.get()

            }
          })
    },
      getAdmins() {
          depositService.getAdministrators()
              .then((res) => {
                  if(res.state){
                      res.data.map(user => {
                          this.admins.push({
                              value: user.id,
                              label: user.username
                          })
                      })
                  }
              })

      },
      getBankAccounts() {
          depositService.bankAccounts({status: true})
              .then((res) => {
                  if(res.state){
                      res.data.map(item => {
                          this.bank_accounts.push({
                              value: item.id,
                              label: item.account_name+'['+item.bank_name+']'
                          })
                      })
                  }
              })

      },
    getStatistics() {
      let admin_id = ''
      if(this.admin_id)
        admin_id = this.admin_id.value
      this.getSiteStatistics()

      depositService.depositsStatistics({bank_account_id: this.bank_account_id, panel_two: this.panel_two, payment_type: this.payment_type, admin_id: admin_id ,account_name: this.account_name, account_number: this.account_number,  name: this.name, site_id: this.activatedSites ,page: this.currentPage,  id: this.id, startDate: this.startDate, endDate: this.endDate, api_trx: this.api_trx})
          .then((res) => {
            if(res.state){
              this.approvedAmount = res.statistics.approvedAmount
              this.approvedTotal = res.statistics.approvedTotal
              this.mailAmount = res.statistics.mailAmount
              this.mailTotal = res.statistics.mailTotal
              this.manualTotal = res.statistics.manualTotal
              this.manualAmount = res.statistics.manualAmount
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    getDetail() {
      this.getStatistics()
    },
    getSiteStatistics() {
      this.siteStatistics = 0
        this.loading = true
      let admin_id = ''
      if(this.admin_id)
        admin_id = this.admin_id.value
      depositService.siteStatistics({bank_account_id: this.bank_account_id, payment_type: this.payment_type, admin_id: admin_id ,account_name: this.account_name, account_number: this.account_number,  name: this.name, site_id: this.activatedSites ,page: this.currentPage,  id: this.id, startDate: this.startDate, endDate: this.endDate, api_trx: this.api_trx})
          .then((res) => {
              this.loading = false
            if(res.state){
              this.siteStatistics = res.data

            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },

  },
  created() {
      this.getBankAccounts()
      this.getSites()
  },
  watch: {
      bank_account_id: function () {
          this.get()
      },
    currentPage: function () {
      this.get()
    },
    tabStatus: function () {
      this.get()
    },
    '$store.getters.newData': function() {
      if(this.$store.getters.newData)
      {
        let deposit_id = this.$store.getters.newData.deposit_id
        let page = this.$store.getters.newData.page

        if(page === 'update-deposit'){
          this.getDetail({id: deposit_id})
        }
      }
    },
  }
};
</script>
<style scoped>
.sites-buttons{
  border-radius: 1rem;
  padding-top: .25rem;
  padding-bottom: .25rem;
}
.sites-buttons:focus, .sites-buttons:hover {
  cursor: pointer;
}
.sites-buttons:focus, .sites-buttons:hover {
  background-color: #fa5252;
}
</style>